export const ITEM_TYPES = {
  CHAPTER: 0,
  DOCUMENT: 1
}

export const TYPES = {
  FOLDER: 0,
  INTEGER: 1,
  DECIMAL: 2,
  STRING: 3,
  DATETIME: 4,
  CODELIST: 5
}



// WEBPACK FOOTER //
// ./src/constants.js